import script from "./BirthDayArc.vue?vue&type=script&setup=true&lang=js"
export * from "./BirthDayArc.vue?vue&type=script&setup=true&lang=js"

import "./BirthDayArc.vue?vue&type=style&index=0&id=85e34924&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-85e34924"]])

export default __exports__